<template>
    <rkm-overlay>
        <rkm-layout-body title="Alto custo - Relatório de processo por paciente">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/relatorio-alto-custo-processo-paciente/List'

export default {
    components: { List },
}
</script>